//Ispirazione page carousel images
import firstSlide from './images/IspirazionePage/slide1.jpg'
import secondSlide from './images/IspirazionePage/slide2.jpg'
import thirdSlide from './images/IspirazionePage/slide3.jpg'
import fourthSlide from './images/IspirazionePage/slide4.jpg'
import fifthSlide from './images/IspirazionePage/slide5.jpg'
import sixthSlide from './images/IspirazionePage/slide6.jpg'
// Realizzazione page image zoom
import imagezoom from './images/SvoltaPage/zoom.jpg'
import imagezoom_mobile from './images/SvoltaPage/mobile.jpg'
// color samples
import calce from './images/ColoriFormatiPage/colors/calce.png'
import lapis from './images/ColoriFormatiPage/colors/lapis.png'
import ocra from './images/ColoriFormatiPage/colors/ocra.png'
import ombra from './images/ColoriFormatiPage/colors/ombra.png'
import terra from './images/ColoriFormatiPage/colors/terra.png'

// format samples
import size1 from './images/ColoriFormatiPage/formats/size1.png'
import size2 from './images/ColoriFormatiPage/formats/size2.png'
import size3 from './images/ColoriFormatiPage/formats/size3.png'
import size4 from './images/ColoriFormatiPage/formats/size4.png'
// decorazioni modal photo
import modalPhoto from './images/DecorazioniPage/zoom.png'
import zoomedModalPhoto from './images/DecorazioniPage/zoomedImg.jpg'
//dettagli page photo
import cuisine from './images/DettagliPage/cuisine.png'
// caratteristiche page photo
import flower from './images/CaratteristichePage/flower.png'
// home video
import home_video from './images/HomePage/02_affrescati_hero_1920x1080.mp4'
import home_video_mobile from './images/HomePage/02_affrescati_hero_375x700.mp4'
// dettaglio immagini
import dettaglio_crepa from './images/DettagliPage/Affrescati_dettagli_crepa_01.jpg'
import dettaglio_manuale from './images/DettagliPage/Affrescati_dettagli_segno_manuale_01.jpg'
import dettaglio_sovrapposizione from './images/DettagliPage/Affrescati_dettagli_sovrapposizione_colori_01.jpg'
import dettaglio_struttura from './images/DettagliPage/Affrescati_dettagli_struttura_01.jpg'

export const HomePageConfig = {
    navElements: [
        'Start',
        'Inspiration',
        'Creation',
        'The turning point',
        'Colours and sizes',
        'Decoration',
        'Details',
        'Characteristics',
        'Collection',
        'Contacts'
    ],
    id:'#start',
    slug:'start',
    title: 'AFFRESCATI',
    secondary: 'TRACES OF HISTORY',
    videoUrl: home_video,
    videoUrlMobile: home_video_mobile
}

export const IspirazionePageConfig = {
	title: 'INSPIRATION',
	slug: 'inspiration',
	id: '#inspiration',
    content: {
        primary: 'The inspiration',
        secondary: 'Imagine walking among the stars of the Scrovegni Chapel, feeling the texture of the frescos in Pompeii that have been redesigned by time, or the blooming colours in Amalfi’s Cathedral. <strong>These are the charming suggestions which inspired Affrescati</strong>.'
    },
    carousel: [
        {
            src: firstSlide,
            text: 'Scrovegni Chapel, Padua'
        },
        {
            src: secondSlide,
            text: 'Scrovegni Chapel, Padua'
        },
        {
            src: thirdSlide,
            text: 'Santo Stefano Church, Bologna'
        },
        {
            src: fourthSlide,
            text: 'Archaeological digs, Pompeii and Ercolano'
        },
        {
            src: fifthSlide,
            text: 'Archaeological digs, Pompeii and Ercolano'
        },
        {
            src: sixthSlide,
            text: 'Amalfi Cathedral, Amalfi'
        }
    ]
}

export const RealizzazionePageConfig = {
	slug:'creation',
    content: {
        primary: 'The creation',
        secondary: 'A veritable <strong>fresco</strong> where Italian art and unique craftsmanship adorn every setting with an <strong>unexpected balance</strong>. In Affrescati, traditional wall decorations liaise freely with contemporary appeal, creating <strong>surfaces affording strong yet concurrently sophisticated contrasts</strong>.'
    },
    videoID: '610809176'
}

export const SvoltaPageConfig = {
	slug:'the_turning_point',
    content: {
        primary: 'The turning point of Affrescati',
        secondary: 'It’s time to explore new perspectives, with a collection that for the first time ever brings <strong>the artistic wealth of frescos to floor tiles too</strong>. For a unique result that simply cannot be achieved with any other material, resulting from a journey amid places and inspirations in pursuit of a <strong>new way to imagine spaces</strong>.'
    },
    zoom: {
        src: imagezoom,
        src_mobile: imagezoom_mobile,
        cta:['Discover Affrescati on the wall','Discover Affrescati on the floor']
    }
}

export const ColoriFormatiPageConfig = {
	slug:'colours_and_sizes',
    content: {
        primary: 'Colours and sizes',
        secondary: '<strong>The traditional pigments of wall colouring</strong>, by nature powdery and vintage, have given rise to a range of <strong>enveloping colours</strong>: Calce, Ocra, Ombra, Lapis and Terra. Each with its own expressive force, capable of enhancing the value of varying tastes and sizes.',
    	tertiary:['Your configuration','Choose a colour','Choose a size','Create a random configuration']
	},
    colors: [
        {
            name: 'terra',
            src: terra
        },
        {
            name: 'ocra',
            src: ocra
        },
        {
            name: 'calce',
            src: calce
        },
        {
            name: 'ombra',
            src: ombra
        },
        {
            name: 'lapis',
            src: lapis
        }
    ],
    formats: [
        {
            primary: '120x120 cm',
            secondary: '48"x48"',
            src: size1
        },
        {
            primary: '60x120 cm',
            secondary: '24"x48"',
            src: size2
        },
        {
            primary: '80x80 cm',
            secondary: '32"x32"',
            src: size3
        },
        {
            primary: '40x80 cm',
            secondary: '16"x32"',
            src: size4
        },
    ]
}

export const DecorazioniPageConfig = {
	slug:'decoration',
    content: {
        primary: 'A starry sky in a room',
        secondary: 'A bewitching array of stars with a <strong>bold personality</strong> and a <strong>refined appearance</strong>, which emphasises the appeal of any setting with its <strong>exclusive character</strong>. The Giotto decoration adorns floor tiles and wall tiles with its soft blue background, where <strong>every star is a gleaming orb</strong> that shines on contact with light.'
    },
    image: modalPhoto,
    zoomedImage: zoomedModalPhoto
}

export const DettagliPageConfig = {
	slug:'details',
    content: {
        primary: 'The art of observing the details',
        secondary: 'Allow yourselves to be surprised by the wealth of details, each guarding a tiny piece of history.'
    },
    images: [dettaglio_crepa, dettaglio_manuale, dettaglio_sovrapposizione, dettaglio_struttura],
    titles:['Cracks and Blossoming', 'Manual element', 'Pictorial element', 'Structure'],
    contents:['The warmth of the past rises back to the surface through cracks and efflorescence that distinguish the surface with all the charm of masonry works.', 'Slight sponging finish embellish each slab with an elegant textural expression, transforming it from a wall decoration into a work of craftsmanship with features that are each time unique and unpredictable.', 'Just like a painter’s palette, several layers of colour overlap to lend each slab a dynamic effect of ceramic depth.', 'A soft structure that is interwoven with the graphic patterns following the tracks of the manual work and reveals gentle textural effects when light is cast upon them from the side.'],
    showPhoto: cuisine,
    modal:['Double-click to enlarge','Drag the cursor to explore']
}

export const CaratteristichePageConfig = {
	slug:'characteristics',
    content: {
        primary: 'Porcelain stoneware. A long-standing story.',
        secondary: '<strong>Sustainable durability</strong> capable of stopping time in its tracks and of capturing the beauty of a fresco on walls and floor tiles for eternity, where real wall decorations would be impossible. <strong>Hygienic, recyclable and easy to clean</strong>, our porcelain stoneware comes from natural elements to offer <strong>unique applications</strong> to this ancient art that has been restyled with modern taste, combining its vintage appeal with guaranteed <strong>maximum healthiness</strong>.',
        expanded: 'Nulla sed rhoncus purus. Sed nibh mauris, tincidunt ut enim sit amet, auctor tempor neque. In nec tempor tortor. Aenean mattis tempus ipsum. Ut accumsan enim non dui sagittis, eget fermentum nunc lobortis. Sed lacinia nisi sit amet risus elementum, eu tristique orci facilisis. Nulla volutpat gravida sapien, vel interdum nibh porta non'
    },
    image: flower
}

export const CollezionePageConfig = {
	slug:'collection',
	title:'The collection',
	cta:['Discover the details of Affrescati','Go to the collection data sheet','Download the catalogue'],
	url:['','https://www.refin-ceramic-tiles.com/series/affrescati/','https://www.refin-ceramic-tiles.com/file/Home/Cataloghi/2021/Affrescati.pdf'],
	videoID: '612516236'
}

export const FormConfiguration = {
	title:'Contact Us',
	slug:'contacts',
	id:'#contacts',
    paesi: [
        'Italia',
        'Albania',
        'Germany',
        'France',
        'Inghilterra'
    ],
    citta: [
        'Milano',
        'Torino',
        'Roma',
        'Napoli'
    ],
    cap: [
        '20100',
        '12838',
        '123123',
        '1231212'
    ],
    infoSulPrivacy: 'http://wikipedia.al'
}

export const FooterLinks = {
    sedeLegale: '/location',
    showroom: '/location'
}

export const SocialLinks = {
    facebook: 'facebook.com',
    linkedin: 'linkedin.com',
    twitter: 'twitter.com',
    instagram: 'instagram.com',
    pinterest: 'pinterest.com',
    youtube: 'youtube.com'
}